import { render, staticRenderFns } from "./ShopRootPage.vue?vue&type=template&id=287af28d&"
import script from "./ShopRootPage.vue?vue&type=script&lang=js&"
export * from "./ShopRootPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopRootPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VApp,VBtn,VIcon,VSpeedDial})
